import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { Number3 } from '@fabric-web/3d-viewer';
import { Box } from '@mui/material';
import { XYZ_LABELS } from '../constants';

type Props = {
  values: Number3;
  setValues: (values: Number3) => void;
  labels?: string[];
  precision?: number;
  isDisabled?: boolean;
};

const round = (value: number, precision?: number): number => {
  if (!precision) return value;
  const factor = 10 ** precision;
  return Math.round(value * factor) / factor;
};

export const XYZFields = ({
  values,
  setValues,
  labels = XYZ_LABELS,
  precision,
  isDisabled = false,
}: Props) => {
  return (
    <>
      <Stack direction="column">
        {[0, 1, 2].map((index) => (
          <Box key={index} padding={1}>
            <TextField
              key={index}
              label={labels[index]}
              type="number"
              value={round(values[index], precision)}
              onChange={(e) => {
                const value = round(Number.parseFloat(e.target.value), precision) || 0;
                const newValues: Number3 = [...values];
                newValues[index] = value;
                setValues(newValues);
              }}
              onBlur={(e) => {
                const value = round(Number.parseFloat(e.target.value), precision) || 0;
                const newValues: Number3 = [...values];
                newValues[index] = value;
                setValues(newValues);
              }}
              size="small"
              disabled={isDisabled}
            />
          </Box>
        ))}
      </Stack>
    </>
  );
};
